import { useState, useContext, useEffect } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { Dialog, Box, Grid, TextField, MenuItem, styled, DialogTitle, Button, DialogContent, DialogActions, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { API_URL, FILE_UPLOAD_TYPE, TVR_RELATION_TYPE, BATTERY_WARRANTY, TVR_TYPE, ECHARGEUP_ID } from '../constant';
import { LoginContext } from '../context/logincontext';
import { includes, isEmpty, isNull } from 'lodash';
import moment from 'moment';
import axios from 'axios';

const Input = styled('input')({
  display: 'none',
});

const validationSchema = yup.object({
  relation_id: yup.number().required('Field cannot be empty'),
  relation_type: yup.string().required('Field cannot be empty'),
  reference_mobile: yup.string().matches(/^[0-9]{10}$/, "Enter a valid 10-digit mobile number").required("Mobile number is required"),
  loan_amount: yup.number().required('Field cannot be empty'),
  tenure: yup.number().required('Field cannot be empty').test('len', 'Invalid MonthMust be exactly 2 digits', val => val && val.toString().length === 2),
  emi_amount: yup.number().required('Field cannot be empty'),
  battery_warranty: yup.number().required('Field cannot be empty'),
  first_emi_date: yup.date().required('Field cannot be empty')
});

const StyledFileInput = styled('input')({
  display: 'block',
  width: '100%',
  padding: '10px',
  marginTop: '8px',
  border: '1px solid #ccc',
  borderRadius: '5px',
  backgroundColor: '#f9f9f9',
  cursor: 'pointer'
});

export default function TvrForm({ open = false, onClose, data }) {
  const context = useContext(LoginContext);
  const [disable, setDisable] = useState(false);
  const [tvrFile, setTvrFile] = useState([]);

  const formik = useFormik({
    initialValues: {
      loan_id:'',
      customer_id:'',
      loan_amount: '',
      tenure: '',
      emi_amount: '',
      first_emi_date: '',
      relation_id: '',
      relation_type: '',
      tvr_type: '',
      reference_name: '',
      reference_mobile: '',
      battery_warranty: '',
      user_id: context?.user?.user_id,
      status: 'pending',
      source: 'partners_web',
      is_insurer_ascend:false,
      created_by: context.user?.los_staff_id,
      is_edit:false,
      insurance_for: null,
      installation_kit: false,
      created_by_name:'' // Mentioning Key here because key is using Los 
    },
    validationSchema,
    onSubmit: async (values) => {
      let body ={
        ...values,
        loan_id: data[0]?.loan_id,
        customer_id: data[0]?.customer_id,
      } 
      if( includes(ECHARGEUP_ID,context.user?.company?.dealer_id)){
        body = {
          ...body,
          pf_charges: 1520,
          security_amount: 0,
          gps_charges: 1,
          battery_count: 1,
          model_id: 651,
          model_name: 'LITHIUM-ION BATTERY',
          oem_id: 224,
          vehicle_make: 'E-CHARGEUP SOLUTIONS PVT. LTD.'
        }
      }

      try {
        setDisable(true);
        const formData = new FormData();
        formData.append('data', JSON.stringify(body));
        if (!isEmpty(tvrFile)) {
          tvrFile.forEach(file => formData.append(FILE_UPLOAD_TYPE.TVR_RECORDING, file));
        }
        await axios.post(`${API_URL}/loan/${body.loan_id}/tvr`, formData);
        onClose();
        formik.resetForm();
      } catch (error) {
        console.error(error);
      } finally {
        setDisable(false);
      }
    },
  });

  useEffect(() => {
    if (!isNull(formik.values.relation_id)) {
      const selectedMember = data.find(member => member.relation_id === formik.values.relation_id);
      if (selectedMember) {
        formik.setFieldValue('reference_name', selectedMember.name);
        formik.setFieldValue('customer_name', selectedMember.name);
        formik.setFieldValue('reference_mobile', selectedMember.mobile);
        formik.setFieldValue('relation_type', selectedMember.relation_type);
        formik.setFieldValue('insurance_for', selectedMember.relation_id);
      }
    }
  }, [formik.values.relation_id, data]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <h3 style={{ fontWeight: 'bold', }}>Pdc Cheque Details Form</h3>
        <Button onClick={onClose} color="error" variant="outlined">X</Button>
      </DialogTitle>
      <DialogContent>
        <form onSubmit={formik.handleSubmit}>
          <Box sx={{ p: 1 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth select label="Member" name="relation_id" value={formik.values.relation_id} onChange={formik.handleChange} error={formik.touched.relation_id && Boolean(formik.errors.relation_id)} helperText={formik.touched.relation_id && formik.errors.relation_id}>
                  {data?.map((member) => (
                    <MenuItem key={member.relation_id} value={member.relation_id}>{`${member.name}-${member.relation_type}`}</MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth label="Customer Name" name="reference_name" value={formik.values.reference_name} disabled />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth label="Customer Mobile" name="reference_mobile" value={formik.values.reference_mobile} disabled />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth label="Relation Type" name="relation_type" value={formik.values.relation_type} disabled />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth label="Loan Amount" name="loan_amount" type='number' value={formik.values.loan_amount} onChange={formik.handleChange} error={formik.touched.loan_amount && Boolean(formik.errors.loan_amount)} helperText={formik.touched.loan_amount && formik.errors.loan_amount} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth label="Emi amount" name="emi_amount"  type='number' value={formik.values.emi_amount} onChange={formik.handleChange} error={formik.touched.emi_amount && Boolean(formik.errors.emi_amount)} helperText={formik.touched.emi_amount && formik.errors.emi_amount} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth label="Tenure (months)" name="tenure" type='number' inputProps={{maxLength: 2}} value={formik.values.tenure} onChange={formik.handleChange} error={formik.touched.tenure && Boolean(formik.errors.tenure)} helperText={formik.touched.tenure && formik.errors.tenure} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth select label="Battery Warranty" name="battery_warranty" value={formik.values.battery_warranty} onChange={formik.handleChange} error={formik.touched.battery_warranty && Boolean(formik.errors.battery_warranty)} helperText={formik.touched.battery_warranty && formik.errors.battery_warranty}>
                  {
                    Object.values(BATTERY_WARRANTY).map((type, i) => {
                      return <MenuItem value={type}>{type}</MenuItem>
                    })
                  }
                </TextField>
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField fullWidth select label="Tvr Type" name="tvr_type" value={formik.values.tvr_type} onChange={formik.handleChange} error={formik.touched.tvr_type && Boolean(formik.errors.tvr_type)} helperText={formik.touched.tvr_type && formik.errors.tvr_type}>
                  {
                    Object.values(TVR_TYPE).map((type, i) => {
                      return <MenuItem value={type}>{type}</MenuItem>
                    })
                  }
                </TextField>
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField fullWidth type="date" label="First Emi Date*" name="first_emi_date" value={formik.values.first_emi_date} error={formik.touched.first_emi_date && Boolean(formik.errors.first_emi_date)} helperText={formik.touched.first_emi_date && formik.errors.first_emi_date} InputLabelProps={{ shrink: true }}
                  onChange={(event) => {
                    const formattedDate = moment(event.target.value).format('YYYY-MM-DD');
                    formik.setFieldValue('first_emi_date', formattedDate);
                  }}
                />
              </Grid>
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold', marginBottom: '4px' }}>Upload TVR Recording</Typography>
              <StyledFileInput
                type="file"
                accept="audio/*"
                onChange={(e) => setTvrFile(Object.values(e.target.files))}
              />
            </Grid>
          </Box>
        </form>
      </DialogContent>
      <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
        <LoadingButton sx={{ width: "30%" }} loading={disable} onClick={formik.handleSubmit} variant="contained" color="primary">Submit</LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
